import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=c5c42552&scoped=true&lang=html&"
import script from "./BarChart.vue?vue&type=script&lang=js&"
export * from "./BarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c42552",
  null
  
)

export default component.exports